import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

@observer
export class AsideLink extends React.Component {

    static propTypes = {
        isInternal: PropTypes.bool,
        disableFocus: PropTypes.bool,
        to: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        srTextBefore: PropTypes.string,
        srTextAfter: PropTypes.string,
        iconAfterClass: PropTypes.string
    }

    static defaultProps = {
        isInternal: false,
        disableFocus: false
    }


    render() {
        const {isInternal, to, text, srTextAfter, srTextBefore, iconAfterClass, disableFocus} = this.props;
        if (isInternal) {
            return (<div className="aside-content">
                <Link to={to} tabIndex={disableFocus ? '-1' : ''}>
                    <span className="sr-only">{srTextBefore}</span>
                    {text}
                    {iconAfterClass ? <span className={`icon ${iconAfterClass} ltblue`} aria-hidden="true"></span> : ''}
                    <span className="sr-only">{srTextAfter}</span>
                </Link>
            </div>);
        } else {
            return (<div className="aside-content">
                <a href={to} target="_blank" rel="noopener noreferrer" tabIndex={disableFocus ? '-1' : ''}>
                    <span className="sr-only">{srTextBefore}</span>
                    {text}
                    <span className={`icon ${iconAfterClass || 'icon-external-link'} ltblue`} aria-hidden="true"></span>
                    <span className="sr-only">{srTextAfter || '. Link will open in a new window.'}</span>
                </a>
            </div>);
        }
    }
}